const APP_ENV = process.env.REACT_APP_ENV;
const nowUrl = window.location.host;
const isNewHost = nowUrl.indexOf('taoum.cn') > -1; // 新域名判断
const clientId = isNewHost ? '' : `crm_${APP_ENV}`;
export default {
    login_url: `/auth/sso/login?clientId=crm_${APP_ENV}`,
    login_out_url: `/bff/api/rest/loginout?clientId=crm_${APP_ENV}`,
};
